const formatInvoiceValue = (value) => {
  if (value == null || value === "") return "";

  if (value.startsWith("$")) {
    value = value.slice(1);
    return value;
  }
  return value;
};

export const getDefaultProjectDetails = (data) => {
  if (!data) return {};
  return { ...data, invoiceValue: formatInvoiceValue(data?.invoiceValue) };
};

export const PROJECT_DETAILS_TAB_LIST = (isGroup) => {
  return [
    { label: "Basic Info", value: "basic-info" },
    {
      label: isGroup ? "Group Health" : "Project Health",
      value: "project-health",
    },
    // {
    //   label: isGroup ? "Group Cost" : "Project Cost",
    //   value: "project-cost",
    // },
    { label: "Project Assets", value: "projects-assets" },
  ];
};
